import { GeolocationPermissionState } from '@/types/LocationVerification.type';

/**
 * Reads geolocation permission state at GPS evidence capture time via Permissions API.
 * Returns null when the API is unavailable or the query fails.
 */
export async function readGeolocationPermissionStateAtCapture(): Promise<GeolocationPermissionState | null> {
  try {
    if (!navigator?.permissions?.query) {
      return null;
    }
    const status = await navigator.permissions.query({ name: 'geolocation' });
    const state = status?.state;
    if (state === 'granted' || state === 'denied' || state === 'prompt') {
      return state;
    }
    return null;
  } catch {
    return null;
  }
}
